import React, { PureComponent } from "react";
import "./icon.scss";

import Answers from "./components/answer";
import AnswerTwo from "./components/answerTwo";
import ArrowDown from "./components/arrowDown";
import ArrowLeft from "./components/arrowLeft";
import ArrowLeftHome from "./components/arrowLeftHome";
import ArrowRight from "./components/arrowRight";
import ArrowRightHome from "./components/arrowRightHome";
import ArrowUp from "./components/arrowUp";
import Attach from "./components/attach";
import Back from "./components/back";
import Bill from "./components/bill";
import Biology from "./components/biology";
import BiologyXl from "./components/biologyXl";
import Block from "./components/block";
import Board from "./components/board";
import Bug from "./components/bug";
import BugXl from "./components/bugXl";
import Buy from "./components/buy";
import Calendar from "./components/calendar";
import Card from "./components/card";
import Cell from "./components/cell";
import Check from "./components/check";
import CheckTrace from "./components/checktrace";
import ChemXl from "./components/chemXl";
import Chemestry from "./components/chemestry";
import CircleCheck from "./components/circleCheck";
import Clock from "./components/clock";
import ClockMD from "./components/clockmd";
import ClockXL from "./components/clockxl";
import Close from "./components/close";
import CloseSmall from "./components/closeSmall";
import Community from "./components/community";
import CommunityXl from "./components/communityXl";
import ContentHome from "./components/contentHome";
import Contract from "./components/contract";
import Copy from "./components/copy";
import Crown from "./components/crown";
import Dislike from "./components/dislike";
import DislikeTrace from "./components/dislikeTrace";
import Download from "./components/download";
import DownloadXl from "./components/downloadXl";
import Expand from "./components/expand";
import Facebook from "./components/facebook";
import Flower from "./components/flower";
import Forward from "./components/forward";
import Go from "./components/go";
import Hat from "./components/hat";
import Health from "./components/health";
import Hide from "./components/hide";
import Info from "./components/info";
import Instagram from "./components/instagram";
import Inter from "./components/inter";
import Jubiluzinho from "./components/jubiluzinho";
import Lamp from "./components/lamp";
import Level1 from "./components/level1";
import Level2 from "./components/level2";
import Level3 from "./components/level3";
import Like from "./components/like";
import LikeTrace from "./components/likeTrace";
import Live from "./components/live";
import LiveXl from "./components/liveXl";
import Lock from "./components/lock";
import Locker from "./components/locker";
import LockerLarge from "./components/lockerLarge";
import LockerTrace from "./components/lockerTrace";
import Login from "./components/login";
import MathXL from "./components/mathXl";
import Mathematics from "./components/mathematics";
import Max from "./components/max";
import Medal from "./components/medal";
import MedalJubicalouro from "./components/medalJubicalouro";
import Menu from "./components/menu";
import Mic from "./components/mic";
import MicroHome from "./components/microHome";
import Min from "./components/min";
import Monitoria from "./components/monitoria";
import More from "./components/more";
import Notification from "./components/notification";
import Paper from "./components/paper";
import Pencil from "./components/pencil";
import Pending from "./components/pending";
import Physical from "./components/physical";
import PhysicsXL from "./components/physicsXl";
import Play from "./components/play";
import PlayHome from "./components/playHome";
import Plus from "./components/plus";
import Question from "./components/question";
import Remove from "./components/remove";
import RoundCheckXL from "./components/roundCheckxl";
import SealXl from "./components/sealXl";
import Search from "./components/search";
import Send from "./components/send";
import Show from "./components/show";
import Smile from "./components/smile";
import Some from "./components/some";
import StarXL from "./components/starxl";
import Statistic from "./components/statistic";
import Subscriber from "./components/subscriber";
import Tag from "./components/tag";
import TeachersHome from "./components/teachersHome";
import Test from "./components/test";
import Text from "./components/text";
import Trash from "./components/trash";
import Trophy from "./components/trophy";
import Tutorial from "./components/tutorial";
import Twitter from "./components/twitter";
import Unsubscriber from "./components/unsubscriber";
import Upload from "./components/upload";
import User from "./components/user";
import UserXl from "./components/userXl";
import Video from "./components/video";
import Wave from "./components/wave";
import Youtube from "./components/youtube";

class Icon extends PureComponent {
  render() {
    const { icon, height, width, className, style } = this.props;

    switch (icon) {
      case "go":
        return <Go height={height} width={width} className={className} />;
      case "text":
        return <Text height={height} width={width} className={className} />;
      case "bug":
        return <Bug height={height} width={width} className={className} />;
      case "bugXl":
        return <BugXl height={height} width={width} className={className} />;
      case "smile":
        return <Smile height={height} width={width} className={className} />;
      case "trophy":
        return <Trophy height={height} width={width} className={className} />;
      case "board":
        return <Board height={height} width={width} className={className} />;
      case "contract":
        return <Contract height={height} width={width} className={className} />;
      case "biology":
        return <Biology height={height} width={width} className={className} />;
      case "biologyXl":
        return <BiologyXl height={height} width={width} className={className} />;
      case "chemestry":
        return <Chemestry height={height} width={width} className={className} />;
      case "chemXl":
        return <ChemXl height={height} width={width} className={className} />;
      case "roundcheckxl":
        return <RoundCheckXL height={height} width={width} className={className} />;
      case "physical":
        return <Physical height={height} width={width} className={className} />;
      case "mathematics":
        return <Mathematics height={height} width={width} className={className} />;
      case "mathematicsXL":
        return <MathXL height={height} width={width} className={className} />;
      case "pending":
        return <Pending height={height} width={width} className={className} />;
      case "checktrace":
        return <CheckTrace height={height} width={width} className={className} />;
      case "physicsXL":
        return <PhysicsXL height={height} width={width} className={className} />;
      case "paper":
        return <Paper height={height} width={width} className={className} />;
      case "pencil":
        return <Pencil height={height} width={width} className={className} />;
      case "hat":
        return <Hat height={height} width={width} className={className} />;
      case "level1":
        return <Level1 height={height} width={width} className={className} />;
      case "level2":
        return <Level2 height={height} width={width} className={className} />;
      case "level3":
        return <Level3 height={height} width={width} className={className} />;
      case "mic":
        return <Mic height={height} width={width} className={className} />;
      case "live":
        return <Live height={height} width={width} className={className} />;
      case "liveXl":
        return <LiveXl height={height} width={width} className={className} />;
      case "community":
        return <Community height={height} width={width} className={className} />;
      case "communityXl":
        return <CommunityXl height={height} width={width} className={className} />;
      case "search":
        return <Search height={height} width={width} className={className} />;
      case "send":
        return <Send height={height} width={width} className={className} />;
      case "arrowDown":
        return <ArrowDown height={height} width={width} className={className} />;
      case "arrowUp":
        return <ArrowUp height={height} width={width} className={className} />;
      case "cell":
        return <Cell height={height} width={width} className={className} />;
      case "arrowRight":
        return <ArrowRight height={height} width={width} className={className} style={style} />;
      case "arrowLeft":
        return <ArrowLeft height={height} width={width} className={className} />;
      case "notification":
        return <Notification height={height} width={width} className={className} />;
      case "menu":
        return <Menu height={height} width={width} className={className} />;
      case "info":
        return <Info height={height} width={width} className={className} />;
      case "download":
        return <Download height={height} width={width} className={className} />;
      case "downloadXl":
        return <DownloadXl height={height} width={width} className={className} />;
      case "upload":
        return <Upload height={height} width={width} className={className} />;
      case "back":
        return <Back height={height} width={width} className={className} />;
      case "forward":
        return <Forward height={height} width={width} className={className} />;
      case "lock":
        return <Lock height={height} width={width} className={className} />;
      case "trash":
        return <Trash height={height} width={width} className={className} />;
      case "user":
        return <User height={height} width={width} className={className} />;
      case "show":
        return <Show height={height} width={width} className={className} />;
      case "play":
        return <Play height={height} width={width} className={className} />;
      case "more":
        return <More height={height} width={width} className={className} />;
      case "clock":
        return <Clock height={height} width={width} className={className} />;
      case "clockxl":
        return <ClockXL height={height} width={width} className={className} />;
      case "clockmd":
        return <ClockMD height={height} width={width} className={className} />;
      case "min":
        return <Min height={height} width={width} className={className} />;
      case "max":
        return <Max height={height} width={width} className={className} />;
      case "answers":
        return <Answers height={height} width={width} className={className} />;
      case "hide":
        return <Hide height={height} width={width} className={className} />;
      case "close":
        return <Close height={height} width={width} className={className} />;
      case "tag":
        return <Tag height={height} width={width} className={className} />;
      case "expand":
        return <Expand height={height} width={width} className={className} />;
      case "locker":
        return <Locker height={height} width={width} className={className} />;
      case "lockerTrace":
        return <LockerTrace height={height} width={width} className={className} />;
      case "like":
        return <Like height={height} width={width} className={className} />;
      case "likeTrace":
        return <LikeTrace height={height} width={width} className={className} />;
      case "dislike":
        return <Dislike height={height} width={width} className={className} />;
      case "dislikeTrace":
        return <DislikeTrace height={height} width={width} className={className} />;
      case "circleCheck":
        return <CircleCheck height={height} width={width} className={className} />;
      case "check":
        return <Check height={height} width={width} className={className} />;
      case "starxl":
        return <StarXL height={height} width={width} className={className} />;
      case "lamp":
        return <Lamp height={height} width={width} className={className} />;
      case "crown":
        return <Crown height={height} width={width} className={className} />;
      case "test":
        return <Test height={height} width={width} className={className} />;
      case "video":
        return <Video height={height} width={width} className={className} />;
      case "wave":
        return <Wave className={className} />;
      case "playHome":
        return <PlayHome height={height} width={width} className={className} />;
      case "contentHome":
        return <ContentHome height={height} width={width} className={className} />;
      case "microHome":
        return <MicroHome height={height} width={width} className={className} />;
      case "teachersHome":
        return <TeachersHome height={height} width={width} className={className} />;
      case "facebook":
        return <Facebook height={height} width={width} className={className} />;
      case "instagram":
        return <Instagram height={height} width={width} className={className} />;
      case "twitter":
        return <Twitter height={height} width={width} className={className} />;
      case "youtube":
        return <Youtube height={height} width={width} className={className} />;
      case "arrowLeftHome":
        return <ArrowLeftHome height={height} width={width} className={className} />;
      case "arrowRightHome":
        return <ArrowRightHome height={height} width={width} className={className} />;
      case "login":
        return <Login height={height} width={width} className={className} />;
      case "block":
        return <Block height={height} width={width} className={className} />;
      case "health":
        return <Health height={height} width={width} className={className} />;
      case "card":
        return <Card height={height} width={width} className={className} />;
      case "bill":
        return <Bill height={height} width={width} className={className} />;
      case "subscriber":
        return <Subscriber height={height} width={width} className={className} />;
      case "unsubscriber":
        return <Unsubscriber height={height} width={width} className={className} />;
      case "plus":
        return <Plus height={height} width={width} className={className} />;
      case "flower":
        return <Flower height={height} width={width} className={className} />;
      case "remove":
        return <Remove height={height} width={width} className={className} />;
      case "some":
        return <Some height={height} width={width} className={className} />;
      case "userXl":
        return <UserXl height={height} width={width} className={className} />;
      case "lockerLarge":
        return <LockerLarge height={height} width={width} className={className} />;
      case "checkTrace":
        return <CheckTrace height={height} width={width} className={className} />;
      case "buy":
        return <Buy height={height} width={width} className={className} />;
      case "attach":
        return <Attach height={height} width={width} className={className} />;
      case "SealXl":
        return <SealXl height={height} width={width} className={className} />;
      case "jubiluzinho":
        return <Jubiluzinho height={height} width={width} className={className} />;
      case "inter":
        return <Inter height={height} width={width} className={className} />;
      case "tutorial":
        return <Tutorial height={height} width={width} className={className} />;
      case "closeSmall":
        return <CloseSmall height={height} width={width} className={className} />;
      case "medalJubicalouro":
        return <MedalJubicalouro height={height} width={width} className={className} />;
      case "medal":
        return <Medal height={height} width={width} className={className} />;
      case "statistic":
        return <Statistic height={height} width={width} className={className} />;
      case "calendar":
        return <Calendar height={height} width={width} className={className} />;
      case "question":
        return <Question height={height} width={width} className={className} />;
      case "answerTwo":
        return <AnswerTwo height={height} width={width} className={className} />;
      case "monitoria":
        return <Monitoria height={height} width={width} className={className} />;
      case "copy":
        return <Copy height={height} width={width} className={className} />;
      default:
        return null;
    }
  }
}

export default Icon;
